export default __webpack_public_path__ + "static/media/leather_body_NORM-min.ff67b619.png";